import NotFoundPage from './NotFound';

export default NotFoundPage;
